class FormDropzone {
  constructor(el) {
    this.el = el;
    if (document.querySelectorAll("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const zones = document.querySelectorAll("." + this.el);

    zones.forEach((zone) => {
      const input = zone.querySelector('input[type="file"]');
      const text = zone.querySelector(".c-form__dropzone-text");
      if (!input || !text) {
        return;
      }

      const defaultHtml = text.innerHTML;

      const updateLabel = () => {
        if (input.files && input.files.length > 0) {
          zone.classList.add("has-file");
          text.textContent = input.files[0].name;
        } else {
          zone.classList.remove("has-file");
          text.innerHTML = defaultHtml;
        }
      };

      input.addEventListener("change", updateLabel);

      ["dragenter", "dragover"].forEach((type) => {
        zone.addEventListener(type, (e) => {
          e.preventDefault();
          zone.classList.add("is-dragover");
        });
      });

      ["dragleave", "drop"].forEach((type) => {
        zone.addEventListener(type, (e) => {
          e.preventDefault();
          zone.classList.remove("is-dragover");
        });
      });

      zone.addEventListener("drop", (e) => {
        const files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) {
          return;
        }
        // CF7 の input に FileList を直接代入できない環境があるため、
        // DataTransfer 経由でセットを試みる
        try {
          const dt = new DataTransfer();
          dt.items.add(files[0]);
          input.files = dt.files;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (err) {
          // 非対応ブラウザはクリック選択に委ねる
        }
      });
    });
  }
}
